// Singleton pub/sub. Modules never import each other to communicate.

class EventBus {
  constructor() {
    this.listeners = new Map();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event).add(callback);
    return () => this.off(event, callback);
  }

  once(event, callback) {
    const wrapper = (...args) => {
      this.off(event, wrapper);
      callback(...args);
    };
    this.on(event, wrapper);
    return () => this.off(event, wrapper);
  }

  off(event, callback) {
    const cbs = this.listeners.get(event);
    if (!cbs) return;
    cbs.delete(callback);
    if (cbs.size === 0) this.listeners.delete(event);
  }

  emit(event, data) {
    const cbs = this.listeners.get(event);
    if (!cbs) return;
    for (const cb of [...cbs]) {
      try {
        cb(data);
      } catch (e) {
        console.error(`EventBus error [${event}]:`, e);
      }
    }
  }

  clear(event) {
    if (event) this.listeners.delete(event);
    else this.listeners.clear();
  }
}

export const eventBus = new EventBus();

export const Events = {
  // input
  INPUT_MOVE: 'input:move',
  INPUT_START: 'input:start',
  INPUT_MUTE: 'input:mute',
  INPUT_PAUSE: 'input:pause',

  // player
  PLAYER_HOP: 'player:hop',
  PLAYER_LAND: 'player:land',
  PLAYER_BLOCKED: 'player:blocked',
  PLAYER_ADVANCE: 'player:advance',
  PLAYER_BOARD: 'player:board',
  PLAYER_DIE: 'player:die',
  PLAYER_RESPAWN: 'player:respawn',

  // game
  GAME_START: 'game:start',
  GAME_OVER: 'game:over',
  GAME_RESTART: 'game:restart',
  LEVEL_BUILD: 'level:build',
  LEVEL_COMPLETE: 'level:complete',

  // presentation
  SCORE_CHANGE: 'score:change',
  LIVES_CHANGE: 'lives:change',
  LEVEL_CHANGE: 'level:change',
  SHAKE: 'fx:shake',
  BURST: 'fx:burst',
  FLASH: 'fx:flash',
  AUDIO_TOGGLE: 'audio:toggle',
};
